import React, { useEffect, useState } from 'react'
import './style.scss'
import SinglePage from '../../components/common/page/SinglePage'
import { wholeAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import Modal from '../../components/common/modal/Modal'
import AddEditProduct from '../../components/user/add-edit-wh-product/AddEditProduct'
import { BsDatabaseFillX, BsFillTrash3Fill } from 'react-icons/bs'
import { FiEdit2, } from 'react-icons/fi'
import { AiOutlinePlus } from 'react-icons/ai'
import { calculatePercentage } from '../../assets/javascript/find-functions'


const WhProductList = () => {
    const [data, setData] = useState([])
    const [modal, setModal] = useState({ content: null, title: null, status: false })
    const [loading, setLoading] = useState('')

    const openModal = (content, title) => {
        setModal({ ...modal, content, title, status: true })
    }

    const handleRemove = (productId) => {
        const ask = window.confirm('Are you sure remove this product form list ?')
        if (ask) {
            wholeAxios.delete(`/products?_id=${productId}`).then(() => {
                setData((state) => state?.filter((obj) => obj?._id !== productId))
            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    useEffect(() => {
        setLoading('fetch')
        wholeAxios.get('/products').then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            setLoading('')
            toast.error(error.message)
        })
    }, [])


    return (
        <div className="vessel-product-list-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Vessel Filter / Product list']}>
                {data?.[0] ? <TableFilter srlNo={true} topRight={<div className='add-buttons-div'>
                    <button className='add-button' title='Create new'
                        onClick={() => openModal(<AddEditProduct setData={setData} setModal={setModal} />, 'CREATE PRODUCT')} >
                        <AiOutlinePlus /> Create</button>
                </div>}>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Price (₹)</th>
                                <th>Variants (V2)</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((product) => <tr>
                                <td>{product?.product_name}</td>
                                <td>
                                    {product?.price > 0
                                        ? <>
                                            <span style={{ fontWeight: "700", fontSize: '14px' }}>₹{product?.price || 0}</span>
                                            <br></br>
                                            <span style={{ color: 'gray' }}>
                                                ( 9%: ₹{(Number(product?.price || 0) + calculatePercentage(Number(product?.price || 0), 9)).toFixed(2)} |
                                                18%: ₹{(Number(product?.price || 0) + calculatePercentage(Number(product?.price || 0), 18)).toFixed(2)} )
                                            </span>
                                        </>
                                        : "No Price"}
                                </td>
                                <td>{product?.variant_list?.length ? `${product?.variant_list?.length} Items` : 'No Variants'}</td>
                                <td>
                                    <p className={product?.sales_inactive ? 'inactiveBadge' : 'activeBadge'}>Sales</p>
                                    <p className={product?.service_inactive ? 'inactiveBadge' : 'activeBadge'}>Service</p>
                                </td>
                                <td>
                                    <div className="buttons">
                                        <button className='btn-icon-div bg_blue' title='Edit'
                                            onClick={() => openModal(<AddEditProduct product={product} setData={setData} setModal={setModal} />,
                                                'UPDATE PRODUCT')}><FiEdit2 /></button>

                                        <button className='btn-icon-div bg_red' title='Remove'
                                            onClick={() => handleRemove(product?._id)}><BsFillTrash3Fill /></button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </TableFilter>
                    :
                    <Spinner icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={!loading && <div className='add-buttons-div'>
                            <button className='add-button'
                                onClick={() => openModal(<AddEditProduct setData={setData} setModal={setModal} />, 'CREATE PRODUCT')}>
                                <AiOutlinePlus /> Create</button>
                        </div>} />}
            </SinglePage >
        </div >
    )
}

export default WhProductList